<div [class.faded]="loading" class="chart-container">
  <div class="statistics-title-container">
    <div class="statistics-title" data-cy="statTitle">
      {{ 'course.statistics.courseStatistic' | translate }}
    </div>
    <div class="bullets" data-cy="statBullets">
      <div class="bullet">
        <span></span>
        {{ 'question.title' | translate }}
      </div>
      <div class="bullet">
        <span></span>
        {{ 'course.statistics.card' | translate }}
      </div>
    </div>
  </div>
  @if (chartData) {
  <qa-chart
    [data]="chartData"
    [options]="chartOptions"
    (chartClick)="chartClicked($event)"
    chartType="line"
    #chart
  >
  </qa-chart>
  }
  <div class="entity-stats">
    <div class="quiz">
      <qa-quiz-stats
        [stats]="quizStatistic"
        [courseId]="courseId"
      ></qa-quiz-stats>
    </div>
    <div class="quiz">
      <qa-stack-stats
        [stats]="cardStatistic"
        [courseId]="courseId"
      ></qa-stack-stats>
    </div>
  </div>
</div>
